const applySortParams = (sort = {}, curParams = {}) => {
    curParams['sort[0].column'] = sort.column;
    curParams['sort[0].direction'] = sort.direction.toUpperCase();
    return curParams;

}
export default applySortParams;